module.exports = __webpack_public_path__ + "img/kn.0edddebd.svg";